export default __webpack_public_path__ + "static/media/PowerSlugPurple.256.7fd6845c.png";